import { motion } from 'framer-motion';
import { FaMapMarkerAlt, FaWhatsapp, FaUber, FaClock, FaPhoneAlt } from 'react-icons/fa';

const Contact = () => {
  const handleWhatsAppClick = () => {
    window.open('https://wa.me/5562982615656', '_blank');
  };

  const handleUberClick = () => {
    window.open('https://m.uber.com/ul/?action=setPickup&client_id=<your-client-id>&pickup=my_location&dropoff[formatted_address]=Rua%20S-2%2C%20QD.%20S5A%2C%20LT.04%2F05%2C%20913%20-%20St.%20Bela%20Vista%2C%20Goi%C3%A2nia%20-%20GO%2C%2074823-430&dropoff[latitude]=-16.72095501869438&dropoff[longitude]=-49.26239281890653', '_blank');
  };

  const handleGoogleMapsClick = () => {
    window.open('https://www.google.com/maps?q=-16.72095501869438,-49.26239281890653', '_blank');
  };

  return (
    <section id="contato" className="relative py-24 bg-[#F8F3F0] overflow-hidden">
      {/* Círculos decorativos com gradiente */}
      <div className="absolute top-0 left-0 w-96 h-96 rounded-full bg-gradient-to-br from-[#D4B4A8]/20 to-transparent blur-3xl" />
      <div className="absolute bottom-0 right-0 w-96 h-96 rounded-full bg-gradient-to-tl from-[#D4B4A8]/20 to-transparent blur-3xl" />
      <div className="absolute -left-48 top-1/2 w-96 h-96 rounded-full border border-[#D4B4A8]/30 blur-sm" />

      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-4xl md:text-5xl font-bold mb-6 text-[#4A3B36]"
          >
            Como Chegar
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
            className="text-[#6B5C57] text-lg max-w-2xl mx-auto leading-relaxed"
          >
            Consultório em localização privilegiada, com ambiente acolhedor e preparado para receber você com todo conforto.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-start">
          {/* Informações de Contato */}
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="space-y-8 order-2 lg:order-1"
          >
            {/* Card Principal */}
            <div className="bg-white p-8 rounded-2xl shadow-xl backdrop-blur-sm bg-white/80">
              <div className="flex items-start gap-6">
                <div className="bg-gradient-to-br from-[#D4B4A8] to-[#D4B4A8]/70 w-16 h-16 rounded-xl flex items-center justify-center shrink-0 shadow-lg">
                  <FaMapMarkerAlt className="text-2xl text-white" />
                </div>
                <div className="space-y-6 flex-1">
                  <div>
                    <h3 className="text-2xl font-bold mb-2 text-[#4A3B36]">Localização</h3>
                    <p className="text-[#6B5C57] text-lg mb-1">
                      Rua S-2, QD. S5A, LT.04/05, 913<br />
                      St. Bela Vista<br />
                      Goiânia - GO, 74823-430
                    </p>
                  </div>

                  <div>
                    <h4 className="font-semibold text-[#4A3B36] mb-2">Pontos de Referência</h4>
                    <ul className="space-y-2 text-[#6B5C57]">
                      <li className="flex items-center gap-2">
                        <span className="w-1.5 h-1.5 rounded-full bg-[#D4B4A8]" />
                        Atrás do Rede Store - Serrinha
                      </li>
                      <li className="flex items-center gap-2">
                        <span className="w-1.5 h-1.5 rounded-full bg-[#D4B4A8]" />
                        Próximo ao Kintaru Sushi
                      </li>
                      <li className="flex items-center gap-2">
                        <span className="w-1.5 h-1.5 rounded-full bg-[#D4B4A8]" />
                        Acesso pela Av. T-14
                      </li>
                    </ul>
                  </div>

                  <div className="flex flex-wrap gap-4">
                    <button
                      onClick={handleGoogleMapsClick}
                      className="group bg-gradient-to-r from-[#4A3B36] to-[#6B5C57] hover:from-[#6B5C57] hover:to-[#4A3B36] 
                               text-white px-6 py-3 rounded-xl font-medium transition-all duration-500 
                               flex items-center justify-center gap-2 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 w-40"
                    >
                      <FaMapMarkerAlt className="text-lg" />
                      <span>Google Maps</span>
                    </button>
                    <button
                      onClick={handleUberClick}
                      className="group bg-gradient-to-r from-[#4A3B36] to-[#6B5C57] hover:from-[#6B5C57] hover:to-[#4A3B36] 
                               text-white px-6 py-3 rounded-xl font-medium transition-all duration-500 
                               flex items-center justify-center gap-2 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 w-40"
                    >
                      <FaUber className="text-lg" />
                      <span>Uber</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* Card Horário de Funcionamento */}
            <div className="bg-white p-6 rounded-2xl shadow-lg backdrop-blur-sm bg-white/80">
              <div className="flex items-start gap-4">
                <div className="bg-gradient-to-br from-[#D4B4A8] to-[#D4B4A8]/70 w-12 h-12 rounded-xl flex items-center justify-center shrink-0 shadow-md">
                  <FaClock className="text-xl text-white" />
                </div>
                <div>
                  <h4 className="text-lg font-semibold text-[#4A3B36] mb-2">Horário de Atendimento</h4>
                  <p className="text-[#6B5C57]"><strong>Segunda e Quinta:</strong> Atendimentos Presenciais 8h às 20h</p>
                  <p className="text-[#6B5C57]"><strong>Terça, Quarta e Sexta:</strong> Atendimentos Online 8h às 20h</p>
                </div>
              </div>
            </div>

            {/* Card de Agendamento */}
            <div className="bg-white p-8 rounded-2xl shadow-xl backdrop-blur-sm bg-white/80">
              <div className="flex items-start gap-6">
                <div className="bg-gradient-to-br from-[#D4B4A8] to-[#D4B4A8]/70 w-16 h-16 rounded-xl flex items-center justify-center shrink-0 shadow-lg">
                  <FaPhoneAlt className="text-2xl text-white" />
                </div>
                <div>
                  <h3 className="text-2xl font-bold mb-2 text-[#4A3B36]">Agendamento</h3>
                  <p className="text-[#6B5C57] text-lg mb-6">
                    Entre em contato via WhatsApp para agendar sua consulta ou tirar dúvidas sobre o atendimento.
                  </p>
                  <button
                    onClick={handleWhatsAppClick}
                    className="group bg-gradient-to-r from-[#4A3B36] to-[#6B5C57] hover:from-[#6B5C57] hover:to-[#4A3B36] 
                             text-white px-8 py-4 rounded-xl font-medium transition-all duration-500 w-full
                             flex items-center justify-center gap-3 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
                  >
                    <FaWhatsapp className="text-2xl" />
                    <span className="text-lg">Agendar Consulta</span>
                  </button>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Mapa */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="order-1 lg:order-2"
          >
            <div className="bg-white p-4 rounded-2xl shadow-xl backdrop-blur-sm bg-white/80">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3822.502601201139!2d-49.26238321572431!3d-16.720954417448372!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x935ef1346b4c7a7d%3A0x5f8c3c26c77f2f0c!2sRua%20S-2%2C%20913%20-%20St.%20Bela%20Vista%2C%20Goi%C3%A2nia%20-%20GO%2C%2074823-430!5e0!3m2!1spt-BR!2sbr!4v1708440065595!5m2!1spt-BR!2sbr"
                className="w-full h-[800px] rounded-xl"
                style={{ border: 0 }}
                allowFullScreen={false}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
